import { Pencil } from 'lucide-react';
import { useCampaign } from '../../context/CampaignContext';

interface ContextBadgeProps {
  onNavigate?: (path: string) => void;
}

export default function ContextBadge({ onNavigate }: ContextBadgeProps) {
  const { selectedLocations, selectedJobRole } = useCampaign();

  const handleEdit = () => {
    if (onNavigate) {
      onNavigate('/recruit/forecast');
    } else {
      // Fallback to direct navigation if no callback provided
      window.location.href = '/recruit/forecast';
    }
  };

  // Format multiple locations with "and" for the last item
  const formatLocations = (locations: string[]): string => {
    if (locations.length === 0) return '';
    if (locations.length === 1) return locations[0];
    if (locations.length === 2) return `${locations[0]} and ${locations[1]}`;
    
    // For 3 or more: "A, B, and C"
    const allButLast = locations.slice(0, -1).join(', ');
    const last = locations[locations.length - 1];
    return `${allButLast}, and ${last}`;
  };

  // If campaign is set, show the active campaign
  if (selectedLocations.length > 0 && selectedJobRole) {
    const locationsText = formatLocations(selectedLocations);
    
    return (
      <div className="flex items-center gap-2 text-sm text-gray-600">
        <span>
          Hiring: <span className="font-semibold text-gray-900">{selectedJobRole}</span> in{' '}
          <span className="font-semibold text-gray-900">{locationsText}</span>
        </span>
        <button
          onClick={handleEdit}
          className="p-1 hover:bg-gray-100 rounded transition-colors"
          title="Edit campaign"
          aria-label="Edit campaign"
        >
          <Pencil className="w-3.5 h-3.5 text-gray-500 hover:text-gray-700" />
        </button>
      </div>
    );
  }

  // If no campaign is set, show subtle message
  return (
    <button
      onClick={handleEdit}
      className="text-sm text-gray-400 hover:text-gray-600 transition-colors"
    >
      No Campaign Selected
    </button>
  );
}


